import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";

/**
 * Moldura do Nora quando o app abre sem conexão (critério 11): nunca a tela em branco nem a página de erro do
 * navegador. "Tentar de novo" refaz a consulta da sessão.
 */
export function OfflineScreen({ onRetry, retrying = false }: { onRetry: () => void; retrying?: boolean }) {
  return (
    <main className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-bg px-4 pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)] text-center text-ink">
      <span role="img" aria-label="Nora">
        <Logo />
      </span>
      <p className="m-0 text-lg font-semibold">Sem conexão com a internet.</p>
      <Button variant="secondary" disabled={retrying} onClick={onRetry}>
        Tentar de novo
      </Button>
    </main>
  );
}
